import { useContext } from 'react';
import CryptoPricesContext from 'contexts/CryptoPricesContext';

const useCryptoPrices = () => useContext(CryptoPricesContext);

export default useCryptoPrices;
